import { motion } from "framer-motion";
import { Briefcase, Send } from "lucide-react";

const WHATSAPP_NUMBER = "919270425109";

export default function JoinUs() {
  return (
    <section id="join-us" data-testid="join-us-section" className="py-20 md:py-28 bg-gradient-to-br from-[#F0FDFA] to-[#F0F9FF]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <div className="w-16 h-16 rounded-2xl bg-[#14B8A6]/15 flex items-center justify-center mx-auto mb-6">
            <Briefcase className="w-8 h-8 text-[#14B8A6]" strokeWidth={1.5} />
          </div>

          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-[#0F172A] tracking-tight mb-4">
            Join Our Growing Team
          </h2>
          <p className="text-base md:text-lg leading-relaxed text-[#64748B] font-body mb-4 max-w-2xl mx-auto">
            Are you a trained caregiver, nurse, or nanny? We're always looking for compassionate
            professionals to join the CareCrony family. Enjoy competitive pay, flexible schedules,
            and a supportive work environment.
          </p>
          <p className="text-sm text-[#64748B] font-body mb-8">
            Caregivers &middot; Nurses &middot; Nannies &middot; Patient Care Attendants
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=Hi%2C%20I%20am%20interested%20in%20joining%20CareCrony%20as%20a%20caregiver`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="join-us-apply-btn"
              className="inline-flex items-center gap-2 h-12 px-8 rounded-full font-semibold bg-[#14B8A6] text-white hover:bg-[#0D9488] transition-all duration-300 transform hover:-translate-y-1 shadow-lg shadow-teal-500/20 font-body"
            >
              <Send className="w-4 h-4" />
              Apply via WhatsApp
            </a>
            <a
              href="mailto:support@carecrony.com?subject=Job Application - CareCrony"
              data-testid="join-us-email-btn"
              className="inline-flex items-center gap-2 h-12 px-8 rounded-full font-semibold text-[#14B8A6] border-2 border-[#14B8A6] hover:bg-[#F0FDFA] transition-all duration-300 font-body"
            >
              Email Your Resume
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
